import React from 'react'
import ScheduleModalBox from './ScheduleModalBox'

class ScheduleBenefit extends React.Component {
  handleItemClick() {
    if (!this.props.data.no_pop_up) {
      if (this.props.data.just_looking) {
        this.props.handleJustLookingClick(true);
      } else {
        const _this = this;
        $.getJSON(`/leave_plan_benefits/${this.props.data.id}/fetch_details`, data => {
          gon.company_variables = {...gon.company_variables, ...data.statutory_substitutions_options}
          _this.props.handleItemClick('benefit_event', _this.props.data.id, data.description, data.image_url);
        });
      }
    }
  }

  handleItemClose() {
    this.props.handleItemClick('', '', '', '');
  }

  openModalBox() {
    (this.props.display_modal.item_type === 'benefit_event') && (this.props.display_modal.item_id === this.props.data.id);
  }

  renderScheduleModalBox() {
    if(this.openModalBox()){
      <ScheduleModalBox
      item={this.props.data}
      handleItemClose={this.handleItemClose}
      item_type={this.props.display_modal.item_type}
      description={this.props.display_modal.description}
      image_url={this.props.display_modal.image_url}
      onHelpfulCheck={this.props.onHelpfulCheck}/>
    }
  }

  render() {
    return ( 
      <tr className={`schedule-benefit ${this.props.class_name}`}>
        <td className={this.props.icon}></td>
        <td>
          <div className='benefit-name' onClick={this.handleItemClick.bind(this)}>
            {this.props.data.name}
          </div>
          { this.renderScheduleModalBox() }
        </td>
      </tr>
    );
  }
}

export default ScheduleBenefit
